import Cookies from 'js-cookie'
import {
  getUser
} from '@/utils/auth'
const state = {
  cu: getUser(),
  sidebar: {
    allClosed: false,
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  logFlag: 0
}

const mutations = {
  SET_USER: state => {
    state.cu = getUser()
  },
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  CLOSE_ALL_SIDEBAR: (state, withoutAnimation) => {
    state.sidebar.allClosed = true
  },
  OPEN_ALL_SIDEBAR: (state, withoutAnimation) => {
    state.sidebar.allClosed = false
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_LOGFLAG: (state, logFlag) => {
    state.logFlag = logFlag
  }
}

const actions = {
  setUser({
    commit
  }) {
    commit('SET_USER')
  },
  toggleSideBar({
    commit
  }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({
    commit
  }, {
    withoutAnimation
  }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  closeAllSideBar({
    commit
  }) {
    commit('CLOSE_ALL_SIDEBAR')
  },
  openAllSideBar({
    commit
  }) {
    commit('OPEN_ALL_SIDEBAR')
  },
  toggleDevice({
    commit
  }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setLogFlag({
    commit
  }, flag) {
    commit('SET_LOGFLAG', flag)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js